<template>
  <div>
    <VCardTitle
      :class="textClass"
      class="justify-center mb-1 display-2"
    >
      {{ title }}
      <VBtn
        icon
        small
        class="close-button"
        @click="$emit('close')"
      >
        <VIcon large>
          {{ closeIcon }}
        </VIcon>
      </VBtn>
    </VCardTitle>
    <VDivider />
  </div>
</template>

<script>
import { mdiCloseCircleOutline } from '@mdi/js';

export default {
  name: 'AppDialogHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    textClass: {
      type: String,
      default: 'success--text',
    },
  },
  data() {
    return {
      closeIcon: mdiCloseCircleOutline,
    };
  },
};
</script>

<style scoped>
  .close-button {
    position: absolute;
    right: 10px;
    top: 10px;
  }
</style>
